import { render, staticRenderFns } from "./ZoomableGallery.vue?vue&type=template&id=1c41dc4f"
import script from "./ZoomableGallery.vue?vue&type=script&lang=js"
export * from "./ZoomableGallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports